import Vue from 'vue'
import App from './App.vue'
import firebase from 'firebase'
import vuetify from './plugins/vuetify'
import router from './router'
import VueAnalytics from 'vue-analytics'



Vue.config.productionTip = false
var firebaseConfig = {
  apiKey: "AIzaSyDRCzE_GSSBL5XDT4vfb_TQwUQ5tmp78PM",
  authDomain: "matsuo-bord.firebaseapp.com",
  databaseURL: "https://matsuo-bord-default-rtdb.firebaseio.com",
  projectId: "matsuo-bord",
  storageBucket: "matsuo-bord.appspot.com",
  messagingSenderId: "585293719713",
  appId: "1:585293719713:web:39ac0f42d6af211ace68e0"
};

firebase.initializeApp(firebaseConfig);
window.firebase = firebase;

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')

Vue.use(VueAnalytics, {
  id: 'UA-210000617-1',
  router
})
